import React from 'react';
import classname from '@search/classname/src';
import { Modal, Button } from '@vtblife/uikit';
import { Size, Input } from '@vtblife/uikit/legacy';
import { OtpSession } from '../../useSubscribeToPriceChange';
import { useConfirmEmailState } from './useConfirmEmailState';
import './styles.css';

type Props = {
    onClose: () => void;
    email: string;
    otpSession: OtpSession;
    onResetEmail: () => void;
    verifyEmail: (confirmCode: string) => void;
}

const cn = classname.bind(null, 'ConfirmEmailModal');

export const ConfirmEmailModal = ({ verifyEmail, otpSession, email, onResetEmail, onClose }: Props) => {
    const {
        confirmCode,
        changeConfirmCode,
        resendCode,
        timer
    } = useConfirmEmailState();

    const passCodeLength = otpSession.passCodeLength;

    const isValidCode = React.useMemo(() => {
        return confirmCode.length === passCodeLength;
    }, [ confirmCode, passCodeLength ]);

    const onVerify = React.useCallback(() => {
        verifyEmail(confirmCode);
    }, [ confirmCode, verifyEmail ]);

    const onResendCode = React.useCallback(() => {
        resendCode(otpSession);
    }, [ otpSession, resendCode ]);

    const placeholder: string[] = [];

    for (let i = 0; i < passCodeLength; i++) {
        placeholder.push('•');
    }

    return (
        <Modal size='s' opened onClose={onClose}>
            <div className={cn('title')}>
                <Modal.Title>Подтвердите почту</Modal.Title>
            </div>
            <p className={cn('description')}>
                Введите код из письма, отправленного на адрес <b>{email}</b>
            </p>
            <Input
                label='Код из письма'
                placeholder={placeholder.join(' ')}
                type='password'
                size={Size.Large}
                fullWidth
                value={confirmCode}
                onChange={changeConfirmCode}
                className={cn('input')}
                isValid={isValidCode}
                maxLength={passCodeLength}
            />
            <Modal.Actions>
                <Button onClick={onResetEmail} variant='secondary'>Назад</Button>
                <Button disabled={! isValidCode} onClick={onVerify}>Подтвердить</Button>
            </Modal.Actions>
            <div className={cn('retrySend')}>
                {timer > 0 ? (
                    <p>
                        Повторное отправление будет доступно через
                        <span className={cn('timer')}>&nbsp;00:{timer > 9 ? timer : `0${timer}`}</span> сек.
                    </p>
                ) : (
                    <p>
                        Не получили письмо с кодом?<br />
                        <span onClick={onResendCode} className={cn('resend')}>Отправить ещё раз</span>
                    </p>
                )}
            </div>
        </Modal>
    );
};
